import { render } from "./AppFooter.vue?vue&type=template&id=fc12ec52&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=fc12ec52&lang=scss&scoped=true"

import exportComponent from "E:\\Fadi\\Projects\\Vuejs\\my-protfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc12ec52"]])

export default __exports__